import EmailVerification from './EmailVerification';

export default EmailVerification;
